<template>
  <div class="guide-content">
    <div class="guide-content-title">{{ guideContent.title }}</div>
    <div class="guide-content-date">
      {{ guideContent.modify_time.substr(0, 11) }}
    </div>
    <div class="guide-content-inner">
      <div v-if="guideContent.type == 2" class="video">
        <video
          id="video"
          :src="guideContent.files[0].file_url"
          controls="controls"
        />
      </div>
      <div v-else class="text" v-html="guideContent.content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GuideList',
  props: {
    guideContent: Object
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.guide-content {
  padding-left: 80px;
  padding-bottom: 40px;
  .guide-content-title {
    padding-top: 40px;
    font-size: 30px;
    color: $color_black;
    margin-bottom: 10px;
  }
  .guide-content-inner {
    margin-top: 30px;
    #video {
      width: 800px;
    }
    img {
      max-width: 100%;
    }
  }
}
</style>
